import { parse } from 'expression-eval'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { BiEdit } from 'react-icons/bi'
import { CgAddR } from 'react-icons/cg'
import { RiDeleteBinLine } from 'react-icons/ri'
import { Button, CustomInput, Form, FormGroup, Input, Label, Modal, ModalBody, Table} from 'reactstrap'
import styled from 'styled-components'
import noImage from '../../assets/img/no.png'
import yesImage from '../../assets/img/yes.png'
import { history } from '../../redux/history'
import { identityServices, Loader } from '../common'

const ActionIconsStyled = styled.div`
	display: inline-flex;
    font-size: 1.5rem;
    gap: 1rem;
`;

const ModelLabelStyled = styled.div`
	text-align: left;
	font-weight: bold;
`;

const ModelInputStyled = styled.span`
 > input {
	border: 1px solid #ced4da !important;
 }
`;

class StatusConfiguration extends Component {
	constructor(props) {
		super(props)
		this.state = {
			
			title: 'New Status',
			saveLabel: 'Save',
			loading: false,
			openModal: false,
			errorMsg: null,
			tenantId: null,
			formMeta: this.props && this.props.meta && this.props.meta.fields && this.props.meta.fields ? this.props.meta.fields : {},
			formValues: {},
			updateTransitionLabel: "",
			modalFormMeta: {
				caseFields: {
					label: "Case fields",
					name: 'caseFields',
					options: this.props?.itemData?.list || [],
					type: 'select',
					required: true,
					default: '',
				},
				displayCondn: {
					label: 'Display Condition',
					required: true,
					type: 'text',
					name: 'displayCondn',
					placeholder: 'Reason for movement === "awaitingapproval"',
				},
			},
			conditionalField: null
		}
		this.handleChange = this.handleChange.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.handleModalOpen = this.handleModalOpen.bind(this)
		this.handleModalClose = this.handleModalClose.bind(this)
	}

	getRequest() {
		const {
			identity: { profile },
			t,
		} = this.props;
		let headerData = { itemType: "statemovement" };
		this.props.getItems(profile.tenantUid, [`$filter=status eq 'Published'`], 'CaseField', undefined, null, t, null, headerData)
	}

	async getTicketStatus() {
		const { targetTenantDomain, params, location } = this.props
		let apiUrlCustom = `${this.props.apiUrl || (this.props.tenant && this.props.tenant.apiUrl)}/bpm/ProcessFlow/states/${params.id}`
		let axiosConfig = {
			headers: {
				Pragma: 'no-cache',
				'Content-Type': 'application/json',
				targettenantdomain: targetTenantDomain,
			},
		}
		if (location.state && location.state.processFlow?.rowData?.tenantId) {
			apiUrlCustom += `?tenantId=${location.state.processFlow.rowData.tenantId}`
		}
		let response = await identityServices.identityApi.get(apiUrlCustom, axiosConfig);

		let [allowTransitionFromOpt, allowTransitionToOpt] = [[], []];

		response.data.forEach(da => {
			if (da.type !== "Initial" && da.type !== "Done") {
				allowTransitionFromOpt.push({ ...da, value: da.name })
			}
			if (da.type !== "Done" && da.isToAutoMovementAllow ) {
				allowTransitionToOpt.push({ ...da, value: da.name })
			}
		});

		this.setState({
			...this.state,
			formMeta: {
				...this.state.formMeta,
				allowTransitionFrom: {
					...this.state.formMeta.allowTransitionFrom,
					options: allowTransitionFromOpt
				},
				allowTransitionTo: {
					...this.state.formMeta.allowTransitionTo,
					options: allowTransitionToOpt
				}
			}
		})
	}

	getCaseFields = () => {
		const {
			identity: { profile },
			t
		} = this.props;
		let headerData = { itemType: "statemovement" };
		this.props.getOne(profile.tenantUid, [`$filter=status eq 'Published'`], 'CaseField', undefined, null, t, headerData)
	}

	onEdit = (data) => {
		this.setState({
			...this.state,
			title: 'Update Status',
			saveLabel: 'Update',
			formValues: {
				...this.state.formValues,
				...data,
				captureNote: data.captureNote ? "yes" : "no",
				label: data.statusName,
			},
			formMeta: {
				...this.state.formMeta,
				label: {
					...this.state.formMeta.label,
					readOnlyOnEdit: true
				},
				conditionalFields: {
					...this.state.formMeta.conditionalFields,
					tbody: data.caseFields,
				}
			},

		}, () => {
			this.setState({previousTransitionLabel :this.state.formValues.transitionLabel})
		})
	}


	componentWillMount() {
		this.getRequest();
		this.getTicketStatus();
		if (this.props.params && this.props.params.id) {
			this.getCaseFields();
		}
		if (this.props.location && this.props.location.state?.rowData) {
			this.onEdit(this.props.location.state.rowData);
		}
	}

	componentWillReceiveProps(props) {
		const { CaseFieldConfig: { itemData } } = props
		if (itemData.list) {
			this.setState({
				modalFormMeta: {
					...this.state.modalFormMeta,
					caseFields: {
						...this.state.modalFormMeta.caseFields,
						options: itemData.list
					}
				}
			})
		}
	}

	handleChange(event, formField) {
		const { formValues, formMeta } = this.state

		const { type, name, value } = event.target
		let updateFormValues = { ...formValues }, updateFormMeta = { ...formMeta }

		if (type === "checkbox") {
			updateFormValues[name] = !formField.isSelect;
			formMeta[name].isSelect = !formField.isSelect;
		} else {
			updateFormValues[name] = value;
		}
		
		this.setState({
			formValues: updateFormValues,
			formMeta: updateFormMeta
		})
	}

	handleModalOpen() {
		this.setState({
			openModal: true
		})
	}

	handleModalClose() {
		this.setState({
			openModal: false,
			conditionalField: null
		})
	}

	handleModalSubmit = data => {
		const { formMeta, conditionalField } = this.state;

		let conditionalFieldList;

		if (conditionalField) {
			conditionalFieldList = [...formMeta.conditionalFields.tbody.map(tb => {
				if (tb.fieldName === conditionalField.fieldName) {
					return { ...conditionalField, ...data, fieldName: data.caseFields }
				}
				return tb
			})]
		} else {
			conditionalFieldList = [...formMeta.conditionalFields.tbody, { ...conditionalField, ...data, fieldName: data.caseFields, mandatoryField: false }]
		}

		this.setState({
			formMeta: {
				...formMeta,
				conditionalFields: {
					...formMeta.conditionalFields,
					tbody: conditionalFieldList
				}
			}
		})
	}

	handleConditionalFieldSelect = (val, index) => {
		const { formMeta } = this.state
		this.setState({
			formMeta: {
				...formMeta,
				conditionalFields: {
					...formMeta.conditionalFields,
					tbody: [...formMeta.conditionalFields.tbody.map((tr, i) => {
						if (i === index) {
							return { ...tr, mandatoryField: !val }
						} else {
							return { ...tr }
						}
					})]
				}
			}
		})
	}

	handleDeleteConditionalField = (tr) => {
		const { formMeta } = this.state
		let tbody = [...formMeta.conditionalFields.tbody];
		tbody.splice(tbody.indexOf(tr), 1);
		this.setState({
			formMeta: {
				...formMeta,
				conditionalFields: {
					...formMeta.conditionalFields,
					tbody: [...tbody]
				}
			}
		})
	}

	handleEditConditionalField = (tr) => {
		this.setState({
			openModal: true,
			conditionalField: tr
		})
	}

	delete = () => {
		this.setState({ loading: true })
		let { t, location: { state }, params } = this.props
		let appendUrl = `${params.id}`
		this.props.upsertItem({
			entityValues: {
				overrideUrl: `/tickets/ProcessFlow/OverriddenStates/${params.id}`,
				isDeleteData: state.rowData
			},
			t,
			appendUrl
		})
		this.setState({ errorMsg: null })
		setTimeout(() => {
			this.setState({ loading: false })
		}, 300)
	}

	onSubmit(e) {
		e.preventDefault()
		
		const { formValues, formMeta } = this.state
		let { t, params, identity: { profile } } = this.props

		let value = {
			processName: params.id,
			tenantId: profile.tenantUid,
			stateTransition: [{
				...formValues,
				captureNote: formValues.captureNote && formValues.captureNote === "yes" ? true : false,
				overriddenState: true,
				actor: ["ticket_agent", "ticket_agent_supervisor"],
				noteDetails: {
					notifyRequesterOnStatusChange: formValues.notifyRequesterOnStatusChange && formValues.notifyRequesterOnStatusChange === "yes" ? true : false,
					header: "{workflowState.label} Ticket",
					noteType: "statemovement",
					placeHolder: formValues.label,
					headerContent: "This ticket will be moved to <strong>'{workflowState.label}'</strong> Status.<br>Email with <strong>'{workflowState.noteDetails.placeHolder} note'</strong> will be sent to Customer.",
				},
				caseFields: formMeta.conditionalFields.tbody,
				fromState: formValues.allowTransitionFrom,
				toState: formValues.label,
				statusName: formValues.label,
				label: formValues.transitionLabel,
				doAutoMove: false,
			},
			{
				statusName: formValues.label,
				fromState: formValues.label,
				toState: formValues.allowTransitionTo,
				allowTransitionFrom: formValues.allowTransitionFrom,
				allowTransitionTo: formValues.allowTransitionTo,
				doAutoMove: false,
			}]
		}
		
		let appendUrl = `${params.id}`
		this.setState({ loading: true })
		// // this.props.upsertItem({
		// // 	entityValues: {
		// // 		...value,
		// // 		overrideUrl: `/tickets/ProcessFlow/OverriddenStates/${params.id}`,
		// // 		isEditData: this.props.location?.state?.rowData,
		// // 		updateTransitionLabel : this.state.title == "Update Status" ? (formValues.transitionLabel == this.state.previousTransitionLabel) ? false : true : false
		// // 	},
		// // 	t,
		// // 	appendUrl
		// // })
		let entityValues = {
			...value,
			 overrideUrl: `/tickets/ProcessFlow/OverriddenStates/${params.id}`,
			 isEditData: this.props.location?.state?.rowData,
			 updateTransitionLabel : this.state.title == "Update Status" ? (formValues.transitionLabel == this.state.previousTransitionLabel) ? false : true : false
		   }
		 
		   if(this.state.title !== "Update Status"){
			delete entityValues?.updateTransitionLabel
		   }
		 
		   this.props.upsertItem({
			//entityValues: {
			//  ...value,
			//  overrideUrl: `/tickets/ProcessFlow/OverriddenStates/${params.id}`,
			//  isEditData: this.props.location?.state?.rowData,
			//  updateTransitionLabel : this.state.title == "Update Status" ? (formValues.transitionLabel == this.state.previousTransitionLabel) ? false : true : false
			// },
			entityValues: entityValues,
			t,
			appendUrl
		   })
		setTimeout(() => {
			this.setState({ loading: false })
		}, 300)


	}



	render() {
		const { t, location: { state } } = this.props
		const { loading, title, formValues, formMeta, modalFormMeta, openModal, conditionalField, saveLabel } = this.state

		return (
			<div className="animated fadeIn">
				{loading && <Loader />}
				<div className="main-section">
					<div className="main-inner">
						<div className="common-heading">
							<div className="row table-title">
								<div className="col-sm-6">
									<div className="heading">
										<h5>{t(title)}</h5>
									</div>
								</div>
								<div className="col-sm-6">
									<Button color="link" className="pull-right" onClick={() => history.goBack()}>
										{t('Back to List')}
									</Button>
								</div>
							</div>
						</div>
						<section>
							<Form onSubmit={this.onSubmit} className="col-sm-9">
								<pre>{JSON.stringify(this.state.timeZoneList, null, 2)}</pre>
								{formMeta &&
									Object.keys(formMeta).map((field, idx) => {
										let formField = formMeta[field]
										if (formField.create) {
											return (
												<FormGroup className="row" key={idx}>
													<div className="col-sm-3">
														<Label for="exampleEmail">{formField && formField.label ? t(formField.label) : 'Field Name'}</Label>
													</div>
													<div className="col-sm-9">
														{formField && formField.type === 'select' && (
															<Input
																type={formField && formField.type ? formField.type : 'text'}
																name={formField && formField.name ? formField.name : 'formField'}
																value={formValues && formValues[formField.name]}
																className="col-sm-12"
																placeholder={formField && formField.placeholder ? t(formField.placeholder) : ''}
																required={(formField && formField.required) || false}
																onChange={this.handleChange}
																disabled={formField && formField.readOnlyOnEdit}>
																<option value="">{t('--Select--')}</option>
																{formField &&
																	formField.options &&
																	Array.isArray(formField.options) &&
																	formField.options.map((elem, id) => (
																		<option key={id} value={elem.name}>
																			{t(elem.name)}
																		</option>
																	))}
															</Input>
														)}
														{formField && formField.type === 'checkbox' && (
															<input
																style={{ position: "initial" }}
																type="checkbox"
																name={formField.name}
																checked={formValues && formValues[formField.name]}
																value={formField.isSelect}
																onChange={(e) => this.handleChange(e, formField)}
															/>
														)}
														<div className="col-md-22">
															{formField && formField.type === 'table' && (
																<Table className="table">
																	<colgroup>
																		<col width="25%" />
																		<col width="25%" />
																		<col width="10%" />
																		<col width="30%" />
																		<col width="10%" />
																	</colgroup>
																	<thead>
																		<tr>
																			<th>{t('Field Name')}</th>
																			<th>{t('Display Condition')}</th>
																			<th>{t('Mandatory field')}</th>
																			<th>{t('Actions')}</th>
																			<th>
																				{
																					!formField.tbody.length &&
																					<CgAddR style={{ fontSize: "1.5rem" }} onClick={this.handleModalOpen} />
																				}
																			</th>
																		</tr>
																	</thead>
																	<tbody>
																		{
																			formField.tbody.map((tr, index) => {
																				return (
																					<tr key={index}>
																						<td>
																							<div className="reports-top-13">{tr.fieldName}</div>
																						</td>
																						<td>
																							<div className="reports-top-13">{tr.displayCondn}</div>
																						</td>
																						<td>
																							<input
																								style={{ position: "initial" }}
																								type="checkbox"
																								name="mandatoryField"
																								checked={tr.mandatoryField}
																								onChange={() => this.handleConditionalFieldSelect(tr.mandatoryField, index)}
																							/>
																						</td>
																						<td>
																							<ActionIconsStyled>
																								<span>
																									<BiEdit onClick={() => this.handleEditConditionalField(tr)} />
																								</span>
																								<span>
																									<RiDeleteBinLine onClick={() => this.handleDeleteConditionalField(tr)} />
																								</span>
																							</ActionIconsStyled>
																						</td>
																						<td>
																							{
																								(index === formField.tbody.length - 1) && <CgAddR style={{ fontSize: "1.5rem" }} onClick={this.handleModalOpen} />
																							}
																						</td>
																					</tr>
																				)
																			})
																		}
																	</tbody>
																</Table>
															)}
														</div>
														{formField && formField.type === 'radio' &&
															formField.options.map((opt, index) => {
																return (
																	<FormGroup key={index} check inline>
																		<Label check>
																			<CustomInput
																				checked={opt.value === formValues[formField.name]}
																				type="radio"
																				name={formField.name}
																				onChange={this.handleChange}
																				id={`${formField.name}-${index}`}
																				label={t(opt.label)}
																				value={opt.value}
																			/>
																		</Label>
																	</FormGroup>
																)
															})
														}
														{formField && formField.type === 'text' && (
															<Input
																type={formField && formField.type ? formField.type : 'text'}
																name={formField && formField.name ? formField.name : 'formField'}
																value={formValues && formValues[formField.name]}
																placeholder={formField && formField.placeholder ? t(formField.placeholder) : ''}
																required={(formField && formField.required) || false}
																onChange={this.handleChange}
																disabled={formField && formField.readOnlyOnEdit}
															/>
														)}
													</div>
												</FormGroup>
											)
										}
									})}
								<FormGroup>
									<div className="pull-right">
										<Button onClick={() => history.goBack()}>{t('Cancel')}</Button>
									</div>
									<div className="pull-right">

										{state && state.rowData && (
											<Button
												onClick={() => this.delete()}
												style={{ cursor: 'pointer' }}
												color="danger"
											>
												{t('Delete')}
											</Button>
										)}
										{' '}
										<Button color="primary">{t(saveLabel)}</Button>
									</div>
									<div className="clearfix"></div>
								</FormGroup>
						
								{openModal &&
									(
										<ConditionFieldsModal
											t={t}
											modalFormMeta={modalFormMeta}
											openModal={openModal}
											handleModalClose={this.handleModalClose}
											handleModalSubmit={this.handleModalSubmit}
											conditionalFields={formMeta.conditionalFields.tbody.map(tr => tr.caseFields)}
											conditionalField={conditionalField}
										/>
									)
								}
							</Form>
						</section>
					</div>
				</div>
			</div >
		)
	}
}

class ConditionFieldsModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openModal: this.props.openModal ? this.props.openModal : false,
			conditionalFields: this.props.conditionalFields || [],
			caseFieldsMetaData: this.props.caseFieldsMetaData || [],
			formMeta: this.props.modalFormMeta,
			conditionalField: this.props.conditionalField,
			fields: {
				'caseFields': '',
				'fieldName': '',
				'displayCondn': ''
			},
			error: false,
			errMessage: "Required fields are empty",
		};
	}

	componentDidMount() {
		const { modalFormMeta, conditionalFields, conditionalField, fields } = this.props;
		this.setState({
			formMeta: {
				...modalFormMeta,
				caseFields: {
					...modalFormMeta.caseFields,
					options: [...modalFormMeta.caseFields.options.filter(opt => !conditionalFields.includes(opt.fieldProperties.label))]
				}
			},
			fields: conditionalField ? conditionalField : fields
		})
	}

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({
			fields: {
				...this.state.fields,
				[name]: value
			}
		})
	}

	confirm = () => {
		const { fields } = this.state
		if (!fields || !fields.caseFields) {
			return this.setState({ error: true })
		}
		if (fields.displayCondn) {
			try {
				parse(fields.displayCondn);
			} catch (err) {
				return this.setState({ error: true, errMessage: "Invalid display condition" })
			}
		}
		this.props.handleModalSubmit(fields)
		this.props.handleModalClose()
	}
	cancel = () => {
		this.props.handleModalClose()
	}

	render() {
		const { t } = this.props
		const { error, formMeta, fields, errMessage } = this.state

		return (
			<>
				{this.state.openModal && <Modal autoFocus={false} backdrop={true} isOpen={this.state.openModal} toggle={this.props.cancel} className="delete-card ticket-form">
					<h4 className="modal-min-heading">{t("Conditional Fields")}</h4>
					<ModalBody className="ticket-inner-form">
						<Form onSubmit={this.confirm} className="col-sm-9">
							{formMeta &&
								Object.keys(formMeta).map((field, idx) => {
									let formField = formMeta[field]
									return (
										<FormGroup className="row" key={idx}>
											<div className="col-sm-5">
												<Label for="exampleEmail"><ModelLabelStyled>{formField && formField.label ? t(formField.label) : 'Field Name'}</ModelLabelStyled></Label>
											</div>
											<div className="col-sm-9">
												{formField && formField.type === 'select' && (
													<Input
														type={formField && formField.type ? formField.type : 'text'}
														name={formField && formField.name ? formField.name : 'formField'}
														value={fields && fields[formField.name]}
														className="col-sm-12"
														placeholder={formField && formField.placeholder ? t(formField.placeholder) : ''}
														required={(formField && formField.required) || false}
														onChange={this.handleChange}
														disabled={formField && formField.readOnlyOnEdit}>
														<option value={fields && fields[formField.name]}>{t(fields && fields[formField.name] ? fields[formField.name] : '--Select--')}</option>
														{formField &&
															formField.options &&
															Array.isArray(formField.options) &&
															formField.options.map((elem, id) => (
																<option key={id} value={elem.fieldName}>
																	{t(elem.fieldProperties.label)}
																</option>
															))}
													</Input>
												)}
												{formField && formField.type === 'text' && (
													<ModelInputStyled>
														<Input
															type={formField && formField.type ? formField.type : 'text'}
															name={formField && formField.name ? formField.name : 'formField'}
															value={fields && fields[formField.name]}
															placeholder={formField && formField.placeholder ? t(formField.placeholder) : ''}
															required={(formField && formField.required) || false}
															onChange={this.handleChange}
															disabled={formField && formField.readOnlyOnEdit}
														/>
													</ModelInputStyled>
												)}
											</div>
										</FormGroup>
									)
								})}
						</Form>
						{error && <div className={"custom-form-grp clearfix"}><p>{t(errMessage)}</p></div>}
					</ModalBody>
					<div className="button-wrap" style={{ alignItems: 'center' }}>
						<Button color="primary" onClick={this.cancel}><img src={noImage} />{t('Cancel')}</Button>{' '}
						<Button color="primary" onClick={this.confirm}><img src={yesImage} />{t('Save')}</Button>
					</div>
				</Modal>}
			</>
		)
	}
}


export const StatusConfigurationComponent = withTranslation()(StatusConfiguration)